
let AuthorizePanelEvent = {
    Click: "AuthorizePanelEvent.Click", // 点击授权
    Success: "AuthorizePanelEvent.Success"  // 授权成功
}

let AuthorizePanel = xClass("AuthorizePanel", BasePanel, () => { return cc.CSLoader.createNode("cocos/authorizations_authorization.csb")})

AuthorizePanel.prototype.init = function (text, first) {
    let self = this 

    BasePanel.prototype.init.call(self);

    self.notCheckBannerOnPopup();
    self.isFirst = first;

    self.userInfoBtn = null;
    self.openSettingBtn = null;

    self.closeBtn = self.getChildByName("btn_panel_close2");
    self.agreeBtn = self.getChildByName("btn_green_invite");
    self.okBtn = self.getChildByName("btn_green_ok");

    let txt = self.getChildByName("txt");
    let orgTxtHeight = txt.getContentSize().height;
    txt.setString(text);

    if (!mini.isPlatformLogin()) {
        self.agreeBtn.setVisible(false);
        txt.setString(getText("douyin_authorise_login_tip"));
    } else if (mini.supportUserInfoBtn()) {
        self.agreeBtn.setVisible(false);
        self.okBtn.setVisible(false);
    } else {
        self.okBtn.setVisible(false);
    }

    txt.getVirtualRenderer().setDimensions(txt.getContentSize().width, 0);
    let txtSize = txt.getVirtualRenderer().getContentSize();
    txt.setContentSize(txtSize.width, txtSize.height);
    txt.setPosition(txt.x, txt.y + (txtSize.height - orgTxtHeight) * 0.5);
}

AuthorizePanel.prototype.onEnterAnimFinish = function () {
    let self = this
    BasePanel.prototype.onEnterAnimFinish.call(self);
    
    quickBuildUIGLabelButton(self.closeBtn, handler(self, self.closePanel))

    if (self.okBtn.isVisible()) {
        quickBuildUIButton(self.okBtn, handler(self, self.closePanel));
        return;
    }
    if (self.agreeBtn.isVisible()) {      
        quickBuildUIButton(self.agreeBtn, () => self.agreeShowAuthorize());
        return;
    } 
    

    let imageUrl = cc.loader.getFullUrl(getRealResourceName("openData/authorizations_btn.png"));

    let agreeBtn = self.agreeBtn;
    let p1 = agreeBtn.convertToWorldSpace(cc.p(0, 0));
    let p2 = agreeBtn.convertToWorldSpace(cc.p(agreeBtn.getContentSize().width, agreeBtn.getContentSize().height));
    let fs = cc.director.getOpenGLView().getFrameSize()
    let scale = fs.width / cc.winSize.width;//cc.view.getDevicePixelRatio() * fs.width / cc.winSize.width;

    // let node = cc.LayerColor.create(cc.color(255,0,0,100));
    // node.setContentSize(p2.x-p1.x, p2.y-p1.y);
    // node.setPosition(p1.x, p1.y);
    // cc.director._runningScene.addChild(node,9999);

    let btnLeft = (p1.x - cc.winSize.width / 2) * scale + fs.width / 2;
    let btnTop = fs.height / 2 + (cc.winSize.height / 2 - p2.y) * scale;
    let btnWidth = (p2.x - p1.x) * scale
    let btnHeight = (p2.y - p1.y) * scale
    
    if (self.isFirst) {
        self.userInfoBtn = mini.createUserInfoButton({
            type: "image",
            image: imageUrl,
            withCredentials: true,
            style: {
                left: btnLeft,
                top: btnTop,
                width: btnWidth,
                height: btnHeight
            }
        })
        var onUserInfoBtnTapped = function (data) {
            //点击同意授权打点
            if (!self.userInfoBtn) {
                return
            }
            self.userInfoBtn.offTap(onUserInfoBtnTapped)
            self.userInfoBtn.destroy()
            self.userInfoBtn = null

            if (self.isClosed)
                return;

            self.dispatchEvent({ name: AuthorizePanelEvent.Click });
            if (vaildUserBtnResult(data)) {
                self.agreeAuthorize();
            } else {
                self.closePanel()
            }
        }
        self.userInfoBtn.onTap(onUserInfoBtnTapped)
    } else {
        self.openSettingBtn = mini.createOpenSettingButton({
            type: "image",
            image: imageUrl,
            style: {
                left: btnLeft,
                top: btnTop,
                width: btnWidth,
                height: btnHeight
            }
        });

        function onTapOpenSetting() {
            if (!self.openSettingBtn)
                return;
            self.openSettingBtn.offTap(onTapOpenSetting);
            self.openSettingBtn.destroy()
            self.openSettingBtn = null

            if (self.isClosed)
                return;

            //点击同意授权打点                
            self.dispatchEvent({ name: AuthorizePanelEvent.Click });
            mini.getSetting({
                success: function (res) {
                    if (res.authSetting != null && res.authSetting["scope.userInfo"]) {
                        console.log("@@@authorize success")
                        //授权成功打点
                        self.dispatchEvent({ name: AuthorizePanelEvent.Success });
                        self.agreeAuthorize();
                    }
                    else {
                        console.log("@@@authorize deny")
                        self.closePanel()
                    }
                },
                fail: function () {
                    console.log("[!!!!]get setting failed")
                    self.closePanel()
                }
            });
        }
        self.openSettingBtn.onTap(onTapOpenSetting);
    }
}

AuthorizePanel.prototype.agreeShowAuthorize = function () {
    let self = this

    self.dispatchEvent({ name: AuthorizePanelEvent.Click });
    if (self.isFirst) {
        mini.authorize({
            scope: 'scope.userInfo',
            success: res => {
                if (self.isClosed)
                    return;
                self.agreeAuthorize()
            },
            fail: res => {
                if (self.isClosed)
                    return;
                self.closePanel()
            }
        })
    } else {
        mini.openSetting({
            success: function () {
                //点击同意授权打点
                console.log("@@@@openSetting success")
                mini.getSetting({
                    success: function (res) {
                        if (self.isClosed)
                            return;

                        if (res.authSetting != null && res.authSetting["scope.userInfo"]) {
                            console.log("@@@@authorize success")
                            //授权成功打点
                            self.dispatchEvent({ name: AuthorizePanelEvent.Success });
                            self.agreeAuthorize()
                        }
                        else {
                            console.log("@@@@authorize deny")
                            self.closePanel()
                        }
                    },
                    fail: function () {
                        if (self.isClosed)
                            return;
                        console.log("@@@@get setting failed")
                        self.closePanel()
                    }
                });
            },
            fail: function () {
                if (self.isClosed)
                    return;
                console.log("@@@@openSetting failed")
                self.closePanel()
            }
        })
    }
}

AuthorizePanel.prototype.clearAll = function () {
    let self = this;

    if (self.userInfoBtn) {
        self.userInfoBtn.destroy();
        self.userInfoBtn = null;
    }
    if (self.openSettingBtn) {
        self.openSettingBtn.destroy();
        self.openSettingBtn = null;
    }
}

AuthorizePanel.prototype.agreeAuthorize = function () {
    let self = this
    self.clearAll();

    self.onClose(null, "agree");
}

AuthorizePanel.prototype.closePanel = function () {
    let self = this

    self.clearAll();

    self.onClose(null, "deny");
}

AuthorizePanel.prototype.onCleanup = function () {
    let self = this;
    self.clearAll();
    self.removeAllEventListeners();

    ResManager.release("packed/Authorizations.pack");
}


let AuthorizeInstance = {
    panel: null,
    agreeCalls: [],
    denyCalls: [],
    dcTypes: [],
    content: null,
    first: false,
    running: false
}

AuthorizeInstance.showPanel = function (text, agreeCallback, denyCallback, dcType, first) {
    let self = AuthorizeInstance;

    self.content = text;
    self.first = first;

    if (agreeCallback)
        self.agreeCalls.push(agreeCallback);
    if (denyCallback)
        self.denyCalls.push(denyCallback);
    if (dcType)
        self.dcTypes.push(dcType);

    if (!self.running) {
        self.running = true;
        self.start();
    }
}

AuthorizeInstance.start = function () {
    let self = AuthorizeInstance;
    if (self.panel) {
        self.panel.onClose(null, true);
        self.panel = null;
    }
    preloadWithLoading(["packed/Authorizations.pack"], self.popPanel, self.callDeny, self.callAgree, true);
}

AuthorizeInstance.callDeny = function () {
    let self = AuthorizeInstance;

    self.running = false;
    self.agreeCalls.length = 0;
    self.dcTypes.length = 0;

    let denyCalls = Array.from(self.denyCalls);
    self.denyCalls.length = 0;

    denyCalls.forEach(callback => callback(false));
}

AuthorizeInstance.callAgree = function () {
    let self = AuthorizeInstance;

    self.running = false;
    self.denyCalls.length = 0;
    self.dcTypes.length = 0;

    let agreeCalls = Array.from(self.agreeCalls);
    self.agreeCalls.length = 0;

    agreeCalls.forEach(callback => callback(true));
}

AuthorizeInstance.popPanel = function () {
    let self = AuthorizeInstance;

    self.panel = AuthorizePanel.create(self.content, self.first);
    self.panel.popup(true);
    self.panel.on(BasePanelEvent.Close, self.onPanelClose);
    self.panel.on(AuthorizePanelEvent.Click, self.dc4Click);
    self.panel.on(AuthorizePanelEvent.Success, self.dc4Success);
}

AuthorizeInstance.dc4Click = function () {
    let self = AuthorizeInstance;

    self.dcTypes.forEach(dcType => {
        DCAssist.userTrack("user_click", "wechat_info_ask_click", { type: dcType })
    });
}
AuthorizeInstance.dc4Success = function () {
    let self = AuthorizeInstance;

    self.dcTypes.forEach(dcType => {
        DCAssist.userTrack("user_click", "wechat_info_ask_success", { type: dcType })
    });
}

AuthorizeInstance.onPanelClose = function (arg) {
    let self = AuthorizeInstance;

    self.panel = null;
    let closeName = arg.arg;

    console.log("@@@authorize close with arg:" + closeName)

    if (closeName === "agree") {
        self.callAgree();
    } else {
        self.callDeny();
    }
}

// 校验userinfoBtn获取的用户信息，判断授权成功返回true
function vaildUserBtnResult(userInfoBtnData) {    
    console.log("[####]authorizehttp success:"+JSON.stringify(userInfoBtnData))
    let userInfo = userInfoBtnData.userInfo || userInfoBtnData.userinfo;
    if (!userInfo)
        return false;
        
    let nickName = userInfo.nickName || userInfo.nickname;
    let avatarUrl = userInfo.avatarurl || userInfo.headimgurl;

    // let profile = UserManager.getInstance().profile
    // profile.headUrl = avatarUrl
    // profile.name = nickName

    function nothing(){}
    
    function refreshProfile(res){
        var profile = UserManager.getInstance().profile
        profile.headUrl = res.data.avatarUrl
        profile.name = res.data.nickName
    }

    let http = AuthorizeHttp.new()
    http.addEventListener(Events.kComplete, refreshProfile)
    http.addEventListener(Events.kError, nothing)
    http.addEventListener(Events.kCancel, nothing)

    if (userInfoBtnData.rawData && userInfoBtnData.signature) {
        http.load({
            openid: cc.UserDefault.getInstance().getStringForKey("h5game_openid"),
            sessionid: cc.UserDefault.getInstance().getStringForKey("h5sdk_sessionid"),
            rawData: userInfoBtnData.rawData,
            signature: userInfoBtnData.signature
        })
    } else if(nickName && avatarUrl){
        http.load({
            openid: cc.UserDefault.getInstance().getStringForKey("h5game_openid"),
            sessionid: cc.UserDefault.getInstance().getStringForKey("h5sdk_sessionid"),
            nickName:nickName,
            avatarUrl:avatarUrl
        })
    }
    return true;
}
module.exports = { showPanel: AuthorizeInstance.showPanel };